<div [formGroup]="form">
  <div class="field grid">
    <label class="col-fixed">Email sending mechanism</label>
    <div class="col-fixed inputfield">
      <input type="text" readonly pInputText value="Microsoft Exchange OAuth 2.0" class="displayOnly form-control" />
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed">Tenant ID</label>
    <div class="col-fixed inputfield">
      <input type="text" readonly pInputText id="tenantId" formControlName="tenantId" class="displayOnly form-control" />
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed">Client ID</label>
    <div class="col-fixed inputfield">
      <input type="text" readonly pInputText id="clientId" formControlName="clientId" class="displayOnly form-control" />
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed">Client secret</label>
    <div class="col-fixed inputfield">
      <input type="text" readonly pInputText value="************" class="displayOnly form-control" />
    </div>
  </div>
</div>
